import { styled } from '@mui/material';

const PREFIX = 'DeleteableRowHeader';

export const classes = {
  fullCell: `${PREFIX}-fullCell`,
  cellPreviousVersion: `${PREFIX}-cellPreviousVersion`,
  value: `${PREFIX}-value`,
  deleteButton: `${PREFIX}-deleteButton`,
};

export const Root = styled('div')(() => ({
  [`& .${classes.fullCell}`]: {
    width: '18.75rem',
    height: '1.75rem',
    textAlign: 'start',
  },

  [`& .${classes.cellPreviousVersion}`]: {
    width: '11rem',
    height: '1rem',
    marginRight: '16rem',
    textAlign: 'left',
  },

  [`& .${classes.value}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  [`& .${classes.deleteButton}`]: {
    width: '1rem',
  },
}));
